// extracted by mini-css-extract-plugin
export default {"profile-picture":"ProfilePicture_profile-picture__mJdRZ","form-buttons":"ProfilePicture_form-buttons__OJKGK","close-button":"ProfilePicture_close-button__DP8AX"};